import { render, staticRenderFns } from "./MPreRegisterResendComp.vue?vue&type=template&id=f4b5ca90&scoped=true&"
import script from "./MPreRegisterResendComp.vue?vue&type=script&lang=ts&"
export * from "./MPreRegisterResendComp.vue?vue&type=script&lang=ts&"
import style0 from "./MPreRegisterResendComp.vue?vue&type=style&index=0&id=f4b5ca90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b5ca90",
  null
  
)

export default component.exports